const Error = () => {
  return <>Error fetching data!</>;
};

export default Error;
